import Text from '~/components/Text';

interface Props {
  text: string;
  Icon: React.ReactNode;
  onClick: () => void;
}

const ActionItem = ({ text, Icon, onClick }: Props) => {
  return (
    <div className="transitiona-all group">
      <button type="button" onClick={onClick}>
        <div className="flex items-center text-xs opacity-50 hover:opacity-100">
          <Text as="span" size="xs" theme="content" weight="semibold" className="mr-1">
            {Icon}
          </Text>
          <Text as="span" size="xs" theme="content" weight="semibold" className="mr-1">
            {text}
          </Text>
        </div>
      </button>
    </div>
  );
};

export default ActionItem;
